export default {
  collections: [],
  collection: {},
  templates: []
}